export { useMorphemeInfoPanelCompositionCharactersSection } from "#morpheme-info-panel-composition-characters-view";
